/** Shared rules for the create wizard's team-member repeater.
 *
 *  A row the operator added and then thought better of is blank, not invalid —
 *  it is dropped rather than failing the whole creation. A row with something in
 *  it must have a usable, unique email, because that is what the backend
 *  normaliser and TEAM_USERS both key on.
 */
import type { TeamMemberInput } from './types';

export const isTeamEmail = (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());

const isBlank = (m: TeamMemberInput) =>
  !m.email.trim() && !m.first_name.trim() && !m.last_name.trim() && !m.phone.trim();

/** `rows` → `{ members, error }`; `error` is the message to show, or null. */
export function cleanTeamMembers(rows: TeamMemberInput[]): {
  members: TeamMemberInput[];
  error: string | null;
} {
  const members = rows.filter((m) => !isBlank(m));
  const seen = new Set<string>();
  for (const m of members) {
    const email = m.email.trim().toLowerCase();
    if (!isTeamEmail(email)) {
      return { members, error: `Team member “${m.email || '(no email)'}” needs a valid email address.` };
    }
    if (seen.has(email)) return { members, error: `Team member ${email} is listed twice.` };
    seen.add(email);
  }
  return { members, error: null };
}
